import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';
import {
  AssessmentTL2RelationshipCreateModel,
  AssessmentTL2RelationshipHttpModel,
} from './assessment-tl2-relationship.model';

@Injectable({
  providedIn: 'root',
})
export class AssessmentTL2RelationshipHttpService extends SupabaseBaseHttpService<
  'assessments_topics_level_02',
  'learning'
> {
  readonly schema = 'learning';
  readonly tableName = 'assessments_topics_level_02';

  set(
    assessmentId: AssessmentTL2RelationshipHttpModel['assessment_id'],
    topicLevel2Ids: Array<AssessmentTL2RelationshipCreateModel['topic_level_02_id']>,
  ) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .rpc('save_assessment_topics', { target_assessment_id: assessmentId, topics_level_02_ids: topicLevel2Ids })
        .throwOnError()
        .then((res) => res.data),
    );
  }
}
